import { gql } from "@apollo/client";

const USER_INFO = gql`
  fragment UserInfo on User {
    id
    fullname
    email
    status
  }
`;

export const GET_USERS = gql`
  ${USER_INFO}
  query GetUsers($filters: UsersFilters, $pagination: PaginationRequest, $hasRoleId: ID) {
    user {
      pagination(filters: $filters, pagination: $pagination) {
        users {
          ...UserInfo
          departmentID
          branch {
            id
            name
          }
          branches {
            id
            name
          }
          roles {
            name
            id
          }
          hasRole(id: $hasRoleId)
          department {
            name
          }
          categories {
            id
            code
            name
          }
        }
        paginationData {
          total
          limit
          offset
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query GetUser($id: ID!) {
    user {
      get(id: $id) {
        id
        fullname
        email
        telephone
        status
        cityID
        wardID
        address
        departmentID
        avatarURL
        branches {
          id
          name
        }
        department {
          id
          name
        }
        roles {
          name
          id
          permissions {
            id
            code
            name
          }
        }
        categories {
          id
          code
          name
        }
      }
    }
  }
`;

export const GET_WAREHOUSE_ACCOUNTANTS = gql`
  ${USER_INFO}
  query GetWarehouseAccountants($filters: UsersFilters, $pagination: PaginationRequest) {
    user {
      pagination(filters: $filters, pagination: $pagination) {
        users {
          ...UserInfo
          wallet {
            id
            balance
          }
          status
        }
        paginationData {
          total
        }
      }
    }
  }
`;

export const GET_USER_PERMISSIONS = gql`
  query {
    user {
      me {
        permissions
      }
    }
  }
`;

//for now
export const GET_SHIPPER = gql`
  ${USER_INFO}
  query GetUsers($filters: UsersFilters, $pagination: PaginationRequest, $sort: [UserSort!]) {
    user {
      pagination(filters: $filters, pagination: $pagination, sort: $sort) {
        users {
          ...UserInfo
          telephone
          totalOrderDelivery {
            totalWaiting
            totalDelivering
          }
        }
      }
    }
  }
`;

export const GET_STAFFS = gql`
  query GetStaffs($filters: UsersFilters, $pagination: PaginationRequest) {
    user {
      pagination(filters: $filters, pagination: $pagination) {
        users {
          id
          fullname
          telephone
        }
        paginationData {
          total
          limit
          offset
        }
      }
    }
  }
`;

export const LIST_SALESMEN = gql`
  query ListSalesmen($sellerGroupID: ID) {
    user {
      listSalesmen(sellerGroupID: $sellerGroupID) {
        id
        fullname
      }
    }
  }
`;

export const GET_USER_BRANCH = gql`
  query GetBranchIDUser {
    user {
      me {
        id
        fullname
        branches {
          id
          name
        }
      }
    }
  }
`;
